export default {
    title: "Address Verification",
    header: "@:views.address.verified.title",
    message: "Thanks for verifying your address. You can now choose this as a shipping address when you place an order.",
}